import { useState } from 'react';


const Input = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  required = false,
  className = '',
  showForgotPassword = false,
  onForgotPassword,
  error = '', // Add error prop with default value
   onBlur, // Add onBlur prop
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Determine the actual input type
  const getInputType = () => {
    if (type === 'password') {
      return showPassword ? 'text' : 'password';
    }
    return type;
  };

   // Determine input class based on error and focus state
  const getInputClass = () => {
    let inputClass = `form-input ${className}`;
    
    if (error) {
      inputClass += ' input-error';
    }
    
    if (isFocused) {
      inputClass += ' input-focused';
    }
    
    return inputClass;
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div className="input-group">
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
        </label>
      )}
      
      <div className={`input-wrapper ${type === 'password' ? 'password-input-wrapper' : ''}`}>
        <input
          type={getInputType()}
          id={name}
          name={name}
         className={getInputClass()}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
           onFocus={handleFocus}
          onBlur={handleBlur}
          // required={required}
          {...props}
        />
        
        {/* Show eye icon only for password type */}
        {type === 'password' && (
          <img 
            src={showPassword ? '../../assets/eye-on-icon.png' : '../../assets/eye-icon.png'} 
            className='eye-icon' 
            alt={showPassword ? 'Hide password' : 'Show password'}
            onClick={togglePasswordVisibility}
            style={{ cursor: 'pointer' }}
          />
        )}
      </div>

        {/* Display error message */}
        {error && <div className="error-message">{error}</div>}

      {/* Show forgot password link only when enabled */}
      {showForgotPassword && (
        <span 
          className='forgot-password-link'
          onClick={onForgotPassword}
        >
          Forgot Password?
        </span>
      )}
    </div>
  );
};

export default Input;